













































import * as _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

import confirmDialog from '@/dialog/Confirm.vue'
import sortable from '@/components/Sortable.vue'

setNewSortOrder = (collection, item, sortorder) ->
  collection[item.dataset.order].sortorder = sortorder
  collection[item.dataset.order]

export default
  name: 'ActivitiesAdministration'
  data: () ->
    edit_type: 
      name: null
    edit_uid: null
    new_type:
      name: null
    show: 
      confirm: false
      message: ''
      action: null

  components:
    'v-dialog-confirm': confirmDialog

  directives:
    'sortable': sortable

  methods:
    cancel: ->
      @$store.dispatch 'showDialog', null
      @show.confirm = false

    addType: () ->
      @new_type.sortorder = @activity_types.getEmbeds('activity_type').length
      await @$store.dispatch 'addActivityType', @new_type
      @new_type.name = null

    deleteType: (type) ->
      @show.message = 'Säker på att du vill radera "' + type.name + '"?'
      @show.action = () => 
        @removeType(type)
      @$store.dispatch 'showDialog', 'confirm'

    removeType: (type) ->
      @$store.dispatch 'deleteActivityType', type
      @$store.dispatch 'showDialog', null
      @show.confirm = false

    doEdit: (type) ->
      @edit_uid = type.uid
      @edit_type = _.cloneDeep type

    updateType: (type, evt) ->
      @$store.dispatch 'updateActivityType', type

    reorderTypes: (order) ->
      console.log 'reorderTypes: ', order
      # types = _.cloneDeep @activity_types.getEmbeds 'activity_type'

      # new_types = order.map (item, idx)->
      #   setNewSortOrder this, item, idx
      # , types

      # @$store.dispatch 'updateActivityTypes',
      #   types: new_types

  created: () ->
    if !@are_loaded.resources then await @$store.dispatch 'getServices'
    if !@are_loaded.activity_types then await @$store.dispatch 'getActivityTypes'

  mounted: () ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ()->
    componentHandler.downgradeElements @$el

  computed: {
    mapGetters([
        'isLoaded'
    ])...
    mapState([
      'are_loaded'
      'activity_types'
    ])...
  }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/administration/Activities.vue